import React, { useState } from 'react'
import { FormControlLabel, Checkbox, Button } from '@material-ui/core'
import { COLORES } from '../../../config/colores'
import { Col } from 'react-bootstrap'

export default function OpcionAutodescargable (props) {
  const { initial, handleSubmit } = props
  const [selected, setSelected] = useState(initial ? 'Si' : 'No')
  const options = ['Si', 'No']

  // useEffect(() => {
  //   setSelected(initial ? 'Si' : 'No')
  // }, [initial])

  const changeOption = (option) => {
    setSelected(option)
  }

  const handleClick = () => {
    handleSubmit((selected === 'Si'))
  }

  return (
    <div style={{ padding: '2' }}>
      <h4 style={{ textAlign: 'center' }}>Camión autodescargable</h4>
      <Col md={12} style={{ display: 'flex', justifyContent: 'center' }}>
        {options.map((o) => (
          <FormControlLabel
            key={o}
            control={
              <Checkbox
                onChange={() => { changeOption(o) }}
                color='primary'
                checked={o === selected}
              />
            }
            label={o}
          />
        ))}
      </Col>

      <Col md={12} style={{ margin: '2% auto', display: 'flex', justifyContent: 'center' }}>
        <Button
          variant='contained'
          style={{ backgroundColor: COLORES.grey.dark, color: 'white' }}
          onClick={handleClick}
          disabled={initial === selected}
        >
                    Confirmar
        </Button>
      </Col>
    </div>
  )
}
